export interface BoynerOrderProduct {
  barcode: string;
  productName: string;
  quantity: number;
}

export const boynerOrderProductFromResponse = (
  responseData: any,
): BoynerOrderProduct => ({
  barcode: responseData.barcode,
  productName: responseData.product_name,
  quantity: responseData.quantity,
});
